import React from 'react';

const Blogs = () => {
    return (
        <div>
            <h2 className='text-center my-5'>Comming Soon ...</h2>
        </div>
    );
};

export default Blogs;